import React from 'react';
import { FaUserTie, FaEnvelope, FaPhone, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';

export const SignupStep1Account = ({ formData, handleChange, showPassword, setShowPassword, token }) => (
  <div className="space-y-4" data-testid="step-1">
    <div>
      <label className="block text-gray-700 font-medium mb-2">Full Name *</label>
      <div className="relative">
        <FaUserTie className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600"
          placeholder="Dr. Jane Smith"
          required
          data-testid="name-input"
        />
      </div>
    </div>

    <div>
      <label className="block text-gray-700 font-medium mb-2">Email Address *</label>
      <div className="relative">
        <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600"
          placeholder="jane@example.com"
          required
          disabled={!!token}
          data-testid="email-input"
        />
      </div>
    </div>

    <div>
      <label className="block text-gray-700 font-medium mb-2">Phone Number</label>
      <div className="relative">
        <FaPhone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600"
          placeholder="(555) 123-4567"
          data-testid="phone-input"
        />
      </div>
    </div>

    <div>
      <label className="block text-gray-700 font-medium mb-2">Password *</label>
      <div className="relative">
        <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type={showPassword ? 'text' : 'password'}
          name="password"
          value={formData.password}
          onChange={handleChange}
          className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600"
          placeholder="At least 8 characters"
          required
          data-testid="password-input"
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    </div>

    <div>
      <label className="block text-gray-700 font-medium mb-2">Confirm Password *</label>
      <div className="relative">
        <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type={showPassword ? 'text' : 'password'}
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600"
          placeholder="Confirm your password"
          required
          data-testid="confirm-password-input"
        />
      </div>
    </div>
  </div>
);
